import { useState } from 'react';
import PurchaseReportPage from './PurchaseReportPage';
import TotalOrdersPage from './TotalOrdersPage';

// Màn "Báo cáo mua hàng" gồm 2 tab:
// - Tổng hợp: thống kê theo nguồn (Tổng đơn tự đếm từ danh sách quét).
// - Báo cáo mua hàng: danh sách đơn quét tự động (TotalOrders).
export default function PurchaseReportTabs() {
  const [tab, setTab] = useState('summary');
  return (
    <>
      <div className="page-head">
        <div>
          <h2>Báo cáo mua hàng</h2>
          <div className="sub">Tổng hợp theo nguồn + danh sách đơn quét tự động.</div>
        </div>
      </div>

      <div className="seg" style={{ marginBottom: 16 }}>
        <button className={tab === 'summary' ? 'active' : ''} onClick={() => setTab('summary')}>
          Tổng hợp
        </button>
        <button className={tab === 'orders' ? 'active' : ''} onClick={() => setTab('orders')}>
          Báo cáo mua hàng
        </button>
      </div>

      {tab === 'summary' && <PurchaseReportPage embedded />}
      {tab === 'orders' && <TotalOrdersPage embedded />}
    </>
  );
}
